import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import type { RegisterRequest, RegisterResponse } from '../../types';
import { authApi } from '../../authApi';
import type { AxiosError } from 'axios';
import type { TFormErrorResponse } from '@shared/types';
import { MutationKey } from '@shared/config';
import { useAuthSignIn } from '@entities/auth/hooks/useSignIn';

export const useRegister = (): UseMutationResult<
  RegisterResponse,
  AxiosError<TFormErrorResponse>,
  RegisterRequest
> => {
  const signIn = useAuthSignIn();

  return useMutation({
    mutationKey: [MutationKey.AUTH_REGISTER],
    mutationFn: (data: RegisterRequest) => authApi.register(data),
    onSuccess: ({ data, meta }) => {
      signIn({
        tokenExpiresIn: data.expiresIn,
        token: data.accessToken,
        tokenType: data.tokenType,
        refreshToken: data.refreshToken,
        ...meta.user,
      });
    },
  });
};
